import {BaseResponse} from '../../../response/internal/baseresponse';
import {ListRequest} from '../../../view-model/internal/listrequest';

export class Refund {
  transaction_id: string;
  customer_id: string;
  partner_id: string;
  sd_firstname: string;
  sd_middlename: string;
  sd_lastname: string;
  refund_fee: number;
  principal_amount: string;
  turn_amount: string;
  status: string;
  bank_name: string;
  branch_name: string;
  account_number: string;
  reason: string;
  remark: string;
};

export class RefundSearchOption {
  txn_status: Array<string> = new Array<string>();
  option: string;
  keyword: string;
}

export class RefundSearch extends ListRequest {
  option: RefundSearchOption = new RefundSearchOption();
};

export class RefundListResult extends BaseResponse {
  data?: {
    total: number;
    list: Array<Refund>;
  };
}

export class RefundDetailResult extends BaseResponse {
  data?: Refund;
}

export class RefundStatus {
  processing: 'Processing';
  completed: 'Completed';
  discarded: 'Discarded';
  failed: 'Failed';
  na: 'N/A';
}



// WEBPACK FOOTER //
// ./src/app/model/agent/lianlian/refund.ts